export const NOTIFICATIONS = 'NOTIFICATIONS'
export const NOTIFICATIONS_UNREAD_COUNT = 'NOTIFICATIONS_UNREAD_COUNT'
export const NOTIFICATIONS_HIDE = 'NOTIFICATIONS_HIDE'
